export default "__VITE_ASSET__d86340ea__"